import React, { useState } from "react";
import { Button, Grid } from "@mui/material";
export default function YesNo(props) {
  const [query, setQuery] = useState(props.query);
  const [answer, setAnswer] = useState(null);

  const handleYesClick = () => {
    props.onYes();
    setAnswer(true);
  };

  const handleNoClick = () => {
    props.onNo();
    setAnswer(false);
  };

  return (
    <>
      <h3>{query}</h3>
      <br />
      <Grid container spacing={2}>
        {" "}
        <Grid item xs={6}>
          <Button
            fullWidth
            onClick={handleNoClick}
            variant="contained"
            color="secondary"
          >
            No{" "}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button fullWidth onClick={handleYesClick} variant="contained">
            Yes{" "}
          </Button>
        </Grid>
      </Grid>
      {/* {answer !== null && <p>Selected answer: {answer.toString()}</p>} */}
    </>
  );
}
